import { ReactNode } from 'react';

import { Typography, TypographyProps } from '../typography/typography.component';

type ListItemTextProps = {
  children?: ReactNode;
  primary?: ReactNode;
  primaryVariant?: TypographyProps['variant'];
  secondary?: ReactNode;
  secondaryColor?: TypographyProps['color'];
};

export const ListItemText = (props: ListItemTextProps) => {
  const { children, primary, primaryVariant, secondary, secondaryColor } = props;
  return (
    <Typography
      display="flex"
      flexDirection="column"
      flexGrow="1"
      align="left"
      color="inherit"
      variant={primaryVariant}>
      {children}
      {primary}
      {secondary && (
        <Typography variant="body2" component="span" align="left" color={secondaryColor ?? 'textSecondary'}>
          {secondary}
        </Typography>
      )}
    </Typography>
  );
};
